"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getPackageBaseUrl_1 = require("owa-session-store/lib/actions/getPackageBaseUrl");
var url_1 = require("url");
var ATTACH_SVG = require('./svg/attach.svg');
var INLINEIMAGE_SVG = require('./svg/inlineimage.svg');
var EMOJI_SVG = require('./svg/emoji.svg');
var SHOWRIBBON_SVG = require('./svg/showribbon.svg');
function getComposeActionIconName(key) {
    var iconName;
    var isImage = false;
    switch (key) {
        case 'AddAttachment':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), ATTACH_SVG);
            isImage = true;
            break;
        case 'AddInlineImage':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), INLINEIMAGE_SVG);
            isImage = true;
            break;
        case 'AddEmoji':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), EMOJI_SVG);
            isImage = true;
            break;
        case 'ToggleRibbon':
            iconName = url_1.resolve(getPackageBaseUrl_1.default(), SHOWRIBBON_SVG);
            isImage = true;
            break;
        case 'SaveDraft':
            iconName = "Save" /* Save */;
            break;
        case 'InsertSignature':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'ShowFrom':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'SetImportance':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        default:
            iconName = '';
            break;
    }
    return [iconName, isImage];
}
exports.getComposeActionIconName = getComposeActionIconName;
function getReadActionIconName(key) {
    var iconName;
    switch (key) {
        case '-':
            iconName = '-';
            break;
        case 'Reply':
            iconName = "Reply" /* Reply */;
            break;
        case 'ReplyAll':
            iconName = "ReplyAll" /* ReplyAll */;
            break;
        case 'Forward':
            iconName = "Forward" /* Forward */;
            break;
        case 'Delete':
            iconName = "Delete" /* Delete */;
            break;
        case 'MarkReadUnread':
            iconName = "Mail" /* Mail */;
            break;
        case 'FlagUnflag':
            iconName = "Flag" /* Flag */;
            break;
        case 'MarkJunkNotJunk':
            iconName = "MailAlert" /* MailAlert */;
            break;
        case 'MarkAsPhishing':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'Block':
            iconName = "BlockContact" /* BlockContact */;
            break;
        case 'CreateRule':
            iconName = "OutlookLogo" /* OutlookLogo */;
            break;
        case 'Print':
            iconName = "Print" /* Print */;
            break;
        case 'ShowInImmersiveReader':
            iconName = "ReadingMode" /* ReadingMode */;
            break;
        default:
            iconName = '';
            break;
    }
    return [iconName, false];
}
exports.getReadActionIconName = getReadActionIconName;
//# sourceMappingURL=getIconNameFromKey.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/utils/getIconNameFromKey.js
// module id = 3086
// module chunks = 2 3 4